import { render } from "./imageTypesView.vue?vue&type=template&id=19bd9262&scoped=true"
import script from "./imageTypesView.vue?vue&type=script&lang=js"
export * from "./imageTypesView.vue?vue&type=script&lang=js"

import "./imageTypesView.vue?vue&type=style&index=0&id=19bd9262&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19bd9262"

export default script